import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			aboutAboutHeliumSemiconductorsContentSectionHeaderCls: string;
			aboutAboutHeliumSemiconductorsContentSectionTextInnerCls: string;
		}
	},

	slug: string
}

class Semiconductors extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('About About Helium Semiconductors Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutAboutHeliumSemiconductorsContentSectionHeaderCls || '','about_about_helium_semiconductors', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutAboutHeliumSemiconductorsContentSectionTextInnerCls || '','about_about_helium_semiconductors', { animCls: 'animate__fadeInRight25P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Semiconductors;